export const MapaTopo = () => {
  return (

    
    <iframe
        title="Puerto Pichilingue"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1862661.635792728!2d-111.01570380547236!3d24.241393774975638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ba396dbd80e3fb%3A0xac786c856b93aee1!2sTopolobampo!5e0!3m2!1ses!2smx!4v1700263894487!5m2!1ses!2smx"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        zoom={5}


    />
  )
}
export default MapaTopo;